const pad2 = value => String(value).padStart(2, '0')

const parseDateParts = dateInput => {
	if (!dateInput) return null
	if (dateInput instanceof Date && !Number.isNaN(dateInput.getTime())) {
		return {
			year: dateInput.getFullYear(),
			month: dateInput.getMonth() + 1,
			day: dateInput.getDate(),
		}
	}
	if (typeof dateInput === 'number') {
		const asDate = new Date(dateInput)
		return Number.isNaN(asDate.getTime())
			? null
			: {
					year: asDate.getFullYear(),
					month: asDate.getMonth() + 1,
					day: asDate.getDate(),
			  }
	}
	const raw = String(dateInput).trim()
	if (!raw) return null
	const dotMatch = raw.match(/^(\d{2})\.(\d{2})\.(\d{2,4})/)
	if (dotMatch) {
		const day = Number(dotMatch[1])
		const month = Number(dotMatch[2])
		let year = Number(dotMatch[3])
		if (dotMatch[3].length === 2) {
			year += 2000
		}
		return { year, month, day }
	}
	const isoMatch = raw.match(/^(\d{4})-(\d{2})-(\d{2})/)
	if (isoMatch) {
		return {
			year: Number(isoMatch[1]),
			month: Number(isoMatch[2]),
			day: Number(isoMatch[3]),
		}
	}
	const asNumber = Number(raw)
	if (!Number.isNaN(asNumber)) {
		const asDate = new Date(asNumber)
		return Number.isNaN(asDate.getTime())
			? null
			: {
					year: asDate.getFullYear(),
					month: asDate.getMonth() + 1,
					day: asDate.getDate(),
			  }
	}
	const asDate = new Date(raw)
	if (Number.isNaN(asDate.getTime())) return null
	return {
		year: asDate.getFullYear(),
		month: asDate.getMonth() + 1,
		day: asDate.getDate(),
	}
}

const parseTimeParts = (timeInput, dateInput) => {
	const matchTime = value => {
		if (!value) return null
		const raw = String(value).trim()
		const match = raw.match(/(\d{2}):(\d{2})(?::(\d{2}))?/)
		if (!match) return null
		return {
			hours: Number(match[1]),
			minutes: Number(match[2]),
			seconds: match[3] ? Number(match[3]) : 0,
		}
	}
	if (timeInput instanceof Date && !Number.isNaN(timeInput.getTime())) {
		return {
			hours: timeInput.getHours(),
			minutes: timeInput.getMinutes(),
			seconds: timeInput.getSeconds(),
		}
	}
	if (typeof timeInput === 'string' || typeof timeInput === 'number') {
		const parsed = matchTime(timeInput)
		if (parsed) return parsed
	}
	if (dateInput instanceof Date && !Number.isNaN(dateInput.getTime())) {
		return {
			hours: dateInput.getHours(),
			minutes: dateInput.getMinutes(),
			seconds: dateInput.getSeconds(),
		}
	}
	if (typeof dateInput === 'string') {
		return matchTime(dateInput)
	}
	return null
}

export const formatDate = dateInput => {
	const parts = parseDateParts(dateInput)
	if (!parts) return ''
	return `${pad2(parts.day)}.${pad2(parts.month)}.${parts.year}`
}

export const formatDateTime = (dateInput, timeInput) => {
	const parts = parseDateParts(dateInput)
	if (!parts) return ''
	const timeParts = parseTimeParts(timeInput, dateInput) || {
		hours: 0,
		minutes: 0,
		seconds: 0,
	}
	return `${pad2(parts.day)}.${pad2(parts.month)}.${parts.year}, ${pad2(
		timeParts.hours
	)}:${pad2(timeParts.minutes)}`
}
